import React from 'react'
import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { ExtendedLink } from '@app/components'
import { InternalTaskStatusTagRender } from '@app/components/renderers'
import { REGISTRY_PAGE } from '@app/constants/page'
import { TASK_TYPE_TITLE } from '@app/constants/taskType'

import { CustomEllipsis } from '@app/constants/customEllipsis'

import { columnTitleSchema } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { InternalTasksDataSource } from '../types'

const getOptions = (): Array<Column<InternalTasksDataSource>> => {
  const columnsKeys = Object.keys(columnTitleSchema).filter(
    key => !['monitoringId', 'taskType', 'status'].includes(key)
  ) as Array<keyof InternalTasksDataSource>

  return columnsKeys.map(key => {
    return {
      customEllipsis: CustomEllipsis,
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }
  })
}

export const getColumns = (): Array<Column<InternalTasksDataSource>> => {
  return getColumnsFromMap<InternalTasksDataSource>({
    columnTitleMap: columnTitleSchema,
    options: [
      ...getOptions(),
      {
        key: 'monitoringId',
        render: (_, { monitoringId }) => (
          <ExtendedLink
            to={ `${REGISTRY_PAGE.registry}/${monitoringId}` }
            target='_blank'
          >
            Ссылка
          </ExtendedLink>
        )
      },
      {
        key: 'taskType',
        sorter: (a, b) => sorterDispatcher(a.taskType, b.taskType),
        render: (_, { taskType }) => (taskType ? TASK_TYPE_TITLE[taskType] : 'Неизвестный тип')
      },
      {
        key: 'status',
        sorter: (a, b) => sorterDispatcher(a.status, b.status),
        render: (_, { status }) => <InternalTaskStatusTagRender status={ status } />
      }
    ]
  })
}
